// extracted by mini-css-extract-plugin
export default {"fluid":"ForgotPassword_fluid__tgwIl","fluidXsUp":"ForgotPassword_fluidXsUp__-EOto"};